import React from "react";

const isIncome = Math.round(Math.random());

function InfoCard() {
  return (
    <div style={{ textAlign: "center", padding: "0 10% 10px" }}>
      Try saying:
      <br />
      Add {isIncome ? "Income " : "Expense "}
      for ${isIncome ? "1000 " : "50 "}
      in Catagory {isIncome ? "Deposits " : "Food "}
      on {isIncome ? "Monday " : "Sunday "} ...
    </div>
  );
}

export default InfoCard;
